import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=ba4ca268&lang=pug"
import script from "./OpenApp.vue?vue&type=script&lang=js"
export * from "./OpenApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports